import React, { Component } from 'react'
import { i18nTranslate, isExpressCheckout } from 'src/utils'
import { observer } from 'mobx-react'
import { observable } from 'mobx'
import { customerContainer, contentStackContainer } from 'src/models'
import { AiOutlineMenu as MenuIcon } from 'react-icons/ai'
import { Container, Modal, Button } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { pageNames } from 'src/routes/pathParams'
import { PageLink as PageLinks } from 'src/views/components/PageLink'

import {
  HeaderLogo,
  mobileMenuState,
  // FavoriteIconWithLink,
} from 'src/views/components'
import { application, getLocaleCodeFromUrl } from 'src/utils'
import { SearchBox } from '../Components'
import { getBuyNowInPDP } from 'config/appConfig'

@observer
class SearchInput extends Component {
  nameSpace = 'ssr-resource'
  @observable searchFocused = false
  @observable searchCleared = false

  constructor(props, context) {
    super(props, context)
  }

  toggleSearchModal = value => {
    this.searchFocused = value
  }

  closeSearchModal = () => {
    this.searchFocused = false
    this.searchCleared = false
  }

  closeSearchSectionModal = () => {
    this.searchFocused = false
  }

  clearSearchModal = value => {
    this.searchCleared = value
  }
  harmsburg = (isGuestB2B, requestDomain) => {
    !isGuestB2B && mobileMenuState?.toggleMenuVisibility()
    // const toggle = !isGuestB2B && mobileMenuState?.toggleMenuVisibility()
    // console.log(mobileMenuState?.toggleMenuVisibility, 'toggle Check')
    // console.log(isGuestB2B, customerContainer?.isGuestB2B, 'Guest Check')
    // console.log('check')
  }

  render() {
    const isGuestB2B = customerContainer.isGuestB2B
    const requestDomain = this.props?.staticContext?.requestDomain || ''
    const nu_skin_rewards_link =
      contentStackContainer.marketingData?.nu_skin_rewards
        ?.nu_skin_rewards_link || ''

    return (
      <div className="SearchBox">
        <div className="nu-header-search-box order-md-2 mb-2 mb-md-2 order-3 w-sm-100">
          <SearchBox
            {...this.props}
            isNuskinHeader
            toggleSearchModal={this.toggleSearchModal}
            clearSearchModal={this.clearSearchModal}
            nuskinReadOnly
          />
        </div>

        <Modal
          className="search-modal"
          show={this.searchFocused && !application.isDesktopOrLarger}
          dialogClassName="search-modal-fullscreen"
          onHide={() => (this.searchFocused = false)}>
          <Modal.Header className="p-0">
            <div className="w-100 h-100 ml-3 my-3">
              <SearchBox
                shouldFocusOnRender={true}
                isNuskinHeader
                closeSearchModal={this.closeSearchModal}
                clearSearchModal={this.clearSearchModal}
                searchCleared={this.searchCleared}
                {...this.props}
              />
            </div>
            <div className="h-100 text-center d-flex justify-content-center nu-mobile-search-cancel">
              <Button
                className="search-modal-cancel-button"
                variant="none"
                onClick={this.closeSearchSectionModal}>
                {i18nTranslate('search.cancel', 'CANCEL', {
                  nameSpace: this.nameSpace,
                })}
              </Button>
            </div>
          </Modal.Header>
          <Modal.Body></Modal.Body>
        </Modal>
      </div>
    )
  }
}

export default SearchInput
